import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { DeadlineService } from '../../../../../services/deadline.service';
import { MedicalService } from '../../../../../services/medical.service';
declare var $: any;

@Component({
  selector: 'app-medical-general-modal',
  templateUrl: './medical-examination-general-modal.component.html',
  styleUrls: ['./medical-examination-general-modal.component.css']
})
export class MedicalExaminationGeneralComponent implements OnInit {

  @Input() ID: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  modalTitle: string;

  lang: any;
  record: any;
  mode: string;

  imageLink: any;
  
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  records: any;
  general: any;

  id: number;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private deadlineService: DeadlineService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private medicalService:MedicalService
  ) { }

  ngOnInit() {

    this.FormBuild();
    this.getData();

    this.config();
  }

  config(): void {
        
    this.typeConfig = [
      { value: 'Quality', text: 'description' },
      { value: 'Safety', text: 'Safety' },
      { value: 'Environment', text: 'Environment' },
      { value: 'Administration', text: 'Administration' },
      { value: 'Various', text: 'Various' },
    ];

  }

  FormBuild(): void {
    
    this.createForm = this.formBuilder.group({
      timetable_discrption: ['', [Validators.required]],
      timetable_renewal_notes: ['', [Validators.required]],
      timetable_type: [null, [Validators.required]],
      timetable_link: this.formBuilder.array([this.newAttachment()]),
      timetable_link_uploaded: this.formBuilder.array([]),
      send_email: this.formBuilder.array([this.newEmail()]),
      id: '',
      action: 'update',
    });

    this.createFormErrorMsg = {
      'timetable_discrption': [{ type: 'required', message: 'This field is Required' }],
      'timetable_renewal_notes': [{ type: 'required', message: 'This field is Required' }],
      'timetable_type': [{ type: 'required', message: 'This field is Required' }],
      'timetable_link': [
        { type: 'validExt', message: 'File format is not supported' }
      ],
      'send_email': [{ type: 'email', message: 'Please enter correct email format' }],
    }

  }

  FormBuildUpdate(): void {

    this.emptyEmail();
    let emails = this.record.send_email.split(',');
    let images = this.record.timetable_link.split(',');

    this.createForm.patchValue({
      timetable_discrption: this.record.timetable_discrption,
      timetable_renewal_notes: this.record.timetable_renewal_notes,
      timetable_type: this.record.timetable_type,
      id: this.record.timetabelId
    });

    if(this.record.send_email) {
      for (const email of emails) {
        this.send_email().push(this.newEmail(email));
      }
    }
    else
      this.send_email().push(this.newEmail());

    if(this.record.timetable_link) {
      for (const image of images) {
        this.timetable_link_uploaded().push(new FormControl(image.split('/').pop()));
      }
    }
    
    
  }

  send_email() : FormArray {
    return this.createForm.get("send_email") as FormArray
  }
   
  newEmail(data = ''): FormControl {
    return new FormControl(data, Validators.email);
  }
   
  addEmail() {
    this.send_email().push(this.newEmail());
  }
   
  removeEmail(i:number) {
    this.send_email().removeAt(i);
  }

  emptyEmail() {
    while (this.send_email().controls.length > 0) {
      this.send_email().removeAt(0);
    }
  }

  timetable_link(): FormArray {
    return this.createForm.get('timetable_link') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      link: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]]
    });
  }

  addAttachment(): void {
    this.timetable_link().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.timetable_link().removeAt(i);
  }

  timetable_link_uploaded(): FormArray {
    return this.createForm.get('timetable_link_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.timetable_link_uploaded().removeAt(i);
  }
  
  public selectAttachment(event: any, index) {

    this.createForm.value.timetable_link[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
          this.createForm.value.timetable_link[index].link = {'name': file.name, 'image': reader.result};
      };
    }
    
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  getData() {
      this.medicalService.FetchDetails(this.ID)
      .subscribe(
      (res) => {
          this.lang = this.medicalService.GeneralGetLangData(res);
          console.log('======= Lang ==========')
          console.log(this.lang)
          // this.records = res.data.deadline_data;
          this.general = res.data.general_data;
          console.log(this.general)

            }
      );
   

  }
}
